
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';


import { API } from '../.././core/app-config';
import { CustomFieldsConfiguration } from './custom-fields-models';


@Injectable()
export class CustomFieldsService {

    constructor(private http: Http) { }

    getCustomFields(entityId: number, panelId: number, recordId: number, companyId: number,LoginId?:number): Observable<CustomFieldsConfiguration[]> {
        var result = this.http.get(API.CUSTOMFILEDS + "/Get?EntityId=" + entityId + "&PanelId=" + panelId + "&RecordId=" + recordId+ "&companyId=" + companyId+ "&LoginId=" + LoginId).pipe(map(res => res.json()));
        return result;
    }
}